import { fromJS } from 'immutable';
import { get } from 'lodash';
import { START, SUCCESS, ERROR } from '@actions/utils';
import { fetchingState } from '@constants';
import * as streamActions from '../actions/stream';

const initialState = {
  loads: {
    state: null,
    data: [],
    triggerReload: false,
    isSubmitting: false,
    loadingStream: false,
    providers: [],
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case streamActions.LOADS_FETCH[START]: {
      return state
        .setIn(['loads', 'state'], fetchingState.FETCHING)
        .setIn(['loads', 'loadingStream'], true);
    }
    case streamActions.LOADS_FETCH[ERROR]: {
      return state
        .setIn(['loads', 'state'], fetchingState.ERROR)
        .setIn(['loads', 'loadingStream'], false)
        .setIn(['loads', 'triggerReload'], false);
    }
    case streamActions.LOADS_FETCH[SUCCESS]: {
      return state
        .setIn(['loads', 'state'], fetchingState.LOADED)
        .setIn(['loads', 'data'], fromJS(get(action, 'data', [])))
        .setIn(['loads', 'triggerReload'], false)
        .setIn(['loads', 'loadingStream'], false)
        .setIn(['loads', 'isSubmitting'], false);
    }
    case streamActions.PROVIDERS_FETCH[SUCCESS]: {
      return state.setIn(
        ['loads', 'providers'],
        fromJS(get(action, 'data', [])),
      );
    }
    case streamActions.DELETE_CREDENTIALS[START]:
    case streamActions.CREATE_CREDENTIALS[START]: {
      return state.setIn(['loads', 'isSubmitting'], true);
    }

    case streamActions.DELETE_CREDENTIALS[SUCCESS]:
    case streamActions.DELETE_CREDENTIALS[ERROR]:
    case streamActions.CREATE_CREDENTIALS[SUCCESS]:
    case streamActions.CREATE_CREDENTIALS[ERROR]: {
      return state.setIn(['loads', 'triggerReload'], true);
    }

    default: {
      return state;
    }
  }
};
